module.exports = __webpack_public_path__ + "img/four-four.415968a1.png";